import exitWhite from "../../assets/exit-white.svg";

const IntakeHistoryItem = (props) => {
  const { item, handleDelete } = props;
  const nutrients = ["calories", "fat", "protein", "carbs"];

  return (
    <li className="intake-history__item">
      <p className="intake-history__item-date">{item.date}</p>
      <div className="intake-history__item-amount">
        <p className="intake-history__item-amount-title">Amount</p>
        <p className="intake-history__item-amount-amount">{item.amount}g</p>
      </div>
      <div className="intake-history__item-nutrition">
        {nutrients.map((nutrient, index) => (
          <div className="intake-history__item-nutrient" key={index}>
            <p className="intake-history__item-nutrient-title">{nutrient}</p>
            <p className="intake-history__item-nutrient-amount">
              {item[nutrient]}
              {nutrient === "calories" ? "cal" : "g"}
            </p>
          </div>
        ))}
      </div>
      <img
        src={exitWhite}
        alt="delete"
        className="intake-history__item-exit"
        onClick={() => {
          handleDelete(item.id);
        }}
      />
    </li>
  );
};

export default IntakeHistoryItem;
